import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaBackwardFast } from "react-icons/fa6";
import CreateService from "./CreateService";
import { ArrowLeftOutlined } from "@ant-design/icons";

import {
  Button,
  Col,
  message,
  Form,
  Popconfirm,
  Switch,
  Row,
  Space,
  notification,
  Table,
  Tooltip,
  Image,
} from "antd";
import { Divider, Flex, Tag, Modal } from 'antd';

import Search from "antd/es/input/Search";

import { components, getRowClassName } from "../../utils/utils";
import IMAGES from "../../const/Image";
import CategoryRequest from "./CategoryRequest";

export const ViewServices = () => {
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState();
  const [filterForm, setFilterForm] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const { id } = useParams();
  const initialFilter = { page: 1, limit: 10 };
  const [categoryDetails, setCategoryDetails] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const navigate = useNavigate();
  const showConfirm = Modal.confirm;
  console.log(categoryDetails?.categoryTitle, 'title')
  useEffect(() => {


  }, [id]);

  const fetchCategoryService = (id) => {
    setLoading(true);
    const getCategoryDetails = async () => {
      setLoading(true);
      try {
        const res = await CategoryRequest.categoryDetail(id);


        const categoryData = res?.data?.data;
        console.log(categoryData)
        if (categoryData) {

          const mappedData = {
            ...categoryData,
            gender: categoryData.gender === 0 ? "Male" : "Female",
            status: categoryData.status === 1 ? "Active" : "Inactive",
          };

          setCategoryDetails(mappedData);
          console.log(setCategoryDetails)


          // if (mappedData.categoryImage) {
          //   setFileList([{ url: mappedData.categoryImage, name: "Uploaded Image" }]);
          // }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };



    if (id) getCategoryDetails();
    // const payload = {
    //   categoryId : id
    // }
    CategoryRequest.getServiceByCategory(id)
      .then((response) => {

        console.log(" full response", response)

        const categoryData = response?.data?.data;
        const categoryKey = Object.keys(categoryData)?.[0];

        

        const rawData = Array.isArray(categoryData[categoryKey]) ? categoryData[categoryKey] : [];
    
        const totalCount = response?.data?.total || 0;
        console.log(rawData, 'ksldjf')

        setLabList(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch categories.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchCategoryService(id);
  }, [filter]);


  const handleStatusChange = (checked, item) => {
    showConfirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this service?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        setLoading(true);
        CategoryRequest.updateService({
          status: checked ? 1 : 0,
          id: item.id,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, status: checked ? 1 : 0 } : el
                )
              );
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };


  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };
  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "categoryId",
      key: "categoryId",
      width: 130,
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Image",
      dataIndex: "serviceImage",
      key: "serviceImage",
      width: 200,
      render: (text) => (
        <img
          src={text || IMAGES.PlaceholderImage}
          alt="Category"
          style={{ width: "100%", height: "66px" }}
        />
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },

    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Update Details">
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/categories/view-service/update/${record.id}`)}
            >
              <img src={IMAGES.EditIcon} alt="Edit" />
            </span>
          </Tooltip>
          {/* <Tooltip title="Delete">
            <Popconfirm
              title="Delete this category?"
              // onConfirm={() => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <span className="action-icon-bg">
                <img src={IMAGES.DeleteIcon} alt="Delete" />
              </span>
            </Popconfirm>
          </Tooltip> */}
        </Space>
      ),
    },
  ];




  return (
    <>
      <div className="">
        <div span={24} style={{ display: "flex", justifyContent: "space-between" }} >

          <Form.Item className="submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <div className="" >
            <Button
              onClick={() => navigate(`/categories/view-service/add/${id}`,)}
              type="primary"
              htmlType="submit"
              className="addcity-btn "
            >
              <img src={IMAGES.AddIconFilters} alt="" />
            </Button>
          </div>
        </div>
        <Row gutter={[20, 20]} justify="space-between" align="middle">
          <div className="viewCategoriesCard">
            <div className="viewCategoriesImg"  >
              {/* <img
                src={categoryDetails.categoryImage || IMAGES.PlaceholderImage}
                alt="Category"
              /> */}
              <Image
                width={100}
                src={categoryDetails.categoryImage || IMAGES.PlaceholderImage}
              />
            </div>
            <div className="viewCategoriesDetails">
              <div className="d-flex justify-content-between align-items-center">
                <h3 style={{ color: "#b31217", marginTop: "0.5rem" }}> {categoryDetails.categoryTitle} Services</h3>
                {/* <div className="viewCategoryBackBtn">
                  <Button type="primary" htmlType="submit" onClick={() => navigate(`/categories/edit/${categoryDetails.id}`)} className="addcity-btn fw-bold">
                    Edit
                  </Button>
                </div> */}



                <Space size="middle">
                  <Tooltip title="Update Details">
                    <span
                      className="action-icon-bg"
                      onClick={() => navigate(`/categories/edit/${categoryDetails.id}`)}
                    >
                      <img src={IMAGES.EditIcon} alt="Edit" />
                    </span>
                  </Tooltip>
                </Space>
              </div>

              <div>

                <div style={{ marginBottom: "15px" }}>
                  {/* <span className="hairCareGender">{categoryDetails.gender}</span> */}

                  {
                    categoryDetails?.gender === "Male" ? (
                      <Tag color={"geekblue"}>{categoryDetails.gender}</Tag>
                    ) : (<Tag color={"magenta"}>{categoryDetails.gender}</Tag>)
                  }
                  {
                    categoryDetails?.status === "Active" ? (
                      <Tag color={"#87d068"}>{categoryDetails.status}</Tag>
                    ) : (<Tag color={"#f50"}>{categoryDetails.status}</Tag>)
                  }


                  {/* <span className="hairCareGender">{categoryDetails.status}</span> */}

                </div>
              </div>
            </div>

          </div>
          {/* <Col style={{
            gap: "5px", width: "100%",

            display: "flex",
            justifyContent: "end"
          }}


          >
            <div className="" >
              <Button
                onClick={() => navigate("/categories/view-service/add")}
                type="primary"
                htmlType="submit"
                className="addcity-btn "
              >
                <img src={IMAGES.AddIconFilters} alt="" />
              </Button>
            </div>

          </Col> */}
        </Row>
      </div>
      <div style={{ marginTop: '20px' }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          dataSource={labList}
          onChange={handleChange}
        />
      </div>

    </>
  );
};
